import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";

const lightbox = new PhotoSwipeLightbox({
  gallery: "#about-us-swiper",
  children: "a",
  pswpModule: () => import("photoswipe"),
});
lightbox.init();
